import { BlockCard } from "src/modules/worksheet/components/WorksheetEditor/components/Editor";

const renderCard = (props: any) => {
    const {
        block: {
            data: {
                v2_voice: { title },
            },
        },
    } = props;
    const tmp = title.find(({ type }: any) => type === "p")?.children[0].text;
    const displayText = tmp
        ? tmp.slice(0, tmp.length > 10 ? 10 : tmp.length)
        : "...";
    return (
        <BlockCard {...props}>
            <div>{displayText}</div>
            <div style={{ fontSize: "11px", fontWeight: "bold" }}>
                V2 Voice Block
            </div>
        </BlockCard>
    );
};

export default renderCard;
